export default ({ get, checkStatus, toJSON }) => ({
  getHeroUnitCarousel: (id) =>
    get(`universe/v2/hero_unit_carousels/search?hero_unit_carousel_ids=[${id}]`)
      .then(checkStatus)
      .then(toJSON),
});
